<script>
import Game from '@/tbs/model/to/Game'

export default {
    //--------------------------------------------------
	// component name
	//--------------------------------------------------
    name: 'game-event-mode',

    //--------------------------------------------------
	// component components
	//--------------------------------------------------
    components: {
    },

    //--------------------------------------------------
    // component props
    //--------------------------------------------------
    props: {
        homeTeamId: String,
        awayTeamId: String,
        eventList: Array,
	},

    //--------------------------------------------------
    // component emits
    //--------------------------------------------------
    emits: ['edit-event'],

    //--------------------------------------------------
    // component data
    //--------------------------------------------------
    data() {
        return {
            locale: new Game
        }
    },

    //--------------------------------------------------
    // computed setter and getter
    //--------------------------------------------------
    computed: {
        filteredEventList() {
            console.log('filteredEventList')
            const events = this.eventList ? this.eventList : []
            let fiteredEvents = []
            // console.log('@events', events)
            let yellowCardTable = {}
            for (let i = 0; i < events.length; i++) {
                let hit = true
                let item = events[i]
                // console.log('item', item.type, item.type == 'yellow')
                if (item.type == 'yellow') {
                    if (yellowCardTable[item.firstPlayerId] == 1) {
                        // console.log('hit the second yellow card')
                        item.type = 'yellow-red'
                        yellowCardTable[item.firstPlayerId] = 2
                    }
                    else {
                        // console.log('record the first yellow card')
                        yellowCardTable[item.firstPlayerId] = 1
                    }
                }
                else if (item.type == 'red') {
                    console.log('red condition', item.firstPlayerId, yellowCardTable[item.firstPlayerId])
                    if (yellowCardTable[item.firstPlayerId] == 2) {
                        hit = false
                        console.log('ingore this red card')
                    }
                    else {
                        yellowCardTable[item.firstPlayerId] = 2
                    }
                }
                if (hit) {
                    fiteredEvents.push(item)
                }
            }
            console.log('@fiteredEvents', fiteredEvents)
            return fiteredEvents
        },
    },

    //--------------------------------------------------
    // component methods
    //--------------------------------------------------
    methods: {
        onEditBtnClick(event) {
            console.log('onEditBtnClick', event)
            this.$emit('edit-event', event)
        },
        firstPlayerField(event) {
            return this.locale.localeProp('event-player-label', {
                num: event.firstPlayerNum ? event.firstPlayerNum : '', 
                name: event.firstPlayerName
            })
        },
        secondPlayerField(event) {
            return this.locale.localeProp('event-player-label', {
                num: event.secondPlayerNum ? event.secondPlayerNum : '', 
                name: event.secondPlayerName
            })
        }
    },
}
</script>

<template>
    <!-- component -->
    <div class="game-event-mode">
        <div class="graphic-section u-outer-margin relative">
            <div class="time-line inline-block">
            </div>
            <div class="event-list inline-block">
                <div class="time-slot justify-center vertical-center b-outer-margin">
                    <div class="game-start">
                        <img src="@/assets/match-team-game/game-start-symbol.svg"/>
                    </div>
                </div>
                <div 
                    v-for="event in filteredEventList" 
                    :key="event.id"
                    class="time-slot justify-center vertical-center b-outer-margin"
                >
                    <div class="home-section">
                        <div v-if="event.teamId == homeTeamId" class="event-card relative">
                            <div v-if="event.type=='goal'" class="goal-type">
                                <div v-if="event.firstPlayerName" class="vertical-center">
                                    <img src="@/assets/match-team-game/goal-symbol.svg"/>
                                    <span class="l-outer-margin minor-text main-secondary-color">{{ firstPlayerField(event) }}</span>
                                </div>
                                <div v-if="event.secondPlayerName" class="t-inner-margin vertical-center">
                                    <img src="@/assets/match-team-game/assist-symbol.svg"/>
                                    <span class="l-outer-margin minor-text main-secondary-color">{{ secondPlayerField(event) }}</span>
                                </div>
                            </div>
                            <div v-else-if="event.type=='penalty'" class="penalty-goal-type">
                                <div v-if="event.firstPlayerName" class="vertical-center">
                                    <img src="@/assets/match-team-game/penalty-goal-symbol.svg"/>
                                    <span class="l-outer-margin minor-text main-secondary-color">{{ firstPlayerField(event) }}</span>
                                </div>
                            </div>
                            <div v-else-if="event.type=='ownGoal'" class="own-goal-type">
                                <div v-if="event.firstPlayerName" class="vertical-center">
                                    <img src="@/assets/match-team-game/own-goal-symbol.svg"/>
                                    <span class="l-outer-margin minor-text main-secondary-color">{{ firstPlayerField(event) }}</span>
                                </div>
                            </div>
                            <div v-else-if="event.type=='red'" class="red-card-type">
                                <div v-if="event.firstPlayerName" class="vertical-center">
                                    <img src="@/assets/match-team-game/red-card-symbol.svg"/>
                                    <span class="l-outer-margin minor-text main-secondary-color">{{ firstPlayerField(event) }}</span>
                                </div>
                            </div>
                            <div v-else-if="event.type=='yellow'" class="yellow-card-type">
                                <div v-if="event.firstPlayerName" class="vertical-center">
                                    <img src="@/assets/match-team-game/yellow-card-symbol.svg"/>
                                    <span class="l-outer-margin minor-text main-secondary-color">{{ firstPlayerField(event) }}</span>
                                </div>
                            </div>
                            <div v-else-if="event.type=='yellow-red'" class="yellow-red-card-type">
                                <div v-if="event.firstPlayerName" class="vertical-center">
                                    <img src="@/assets/match-team-game/yellow-red-card-symbol.svg"/>
                                    <span class="l-outer-margin minor-text main-secondary-color">{{ firstPlayerField(event) }}</span>
                                </div>
                            </div>
                            <div v-else-if="event.type=='changes'" class="subsitution-type">
                                <div v-if="event.firstPlayerName" class="vertical-center">
                                    <img src="@/assets/match-team-game/substitution-down-symbol.svg"/>
                                    <span class="l-outer-margin minor-text main-secondary-color">{{ firstPlayerField(event) }}</span>
                                </div>
                                <div v-if="event.secondPlayerName" class="t-inner-margin vertical-center">
                                    <img src="@/assets/match-team-game/substitution-up-symbol.svg"/>
                                    <span class="l-outer-margin minor-text main-secondary-color">{{ secondPlayerField(event) }}</span>
                                </div>
                            </div>
                            <span class="iconfont iconfont-edit edit-btn" @click="onEditBtnClick(event)"></span>
                        </div>
                    </div>
                    <div class="time-section justify-center vertical-center">
                        <div class="minute-unit justify-center vertical-center">
                            <span class="minor-text main-secondary-color">{{ event.time }}'</span>
                        </div>
                    </div>
                    <div class="away-section">
                    <div v-if="event.teamId == awayTeamId" class="event-card relative">
                            <div v-if="event.type=='goal'" class="goal-type">
                                <div v-if="event.firstPlayerName" class="vertical-center">
                                    <img src="@/assets/match-team-game/goal-symbol.svg"/>
                                    <span class="l-outer-margin minor-text main-secondary-color">{{ firstPlayerField(event) }}</span>
                                </div>
                                <div v-if="event.secondPlayerName" class="t-inner-margin vertical-center">
                                    <img src="@/assets/match-team-game/assist-symbol.svg"/>
                                    <span class="l-outer-margin minor-text main-secondary-color">{{ secondPlayerField(event) }}</span>
                                </div>
                            </div>
                            <div v-else-if="event.type=='penalty'" class="penalty-goal-type">
                                <div v-if="event.firstPlayerName" class="vertical-center">
                                    <img src="@/assets/match-team-game/penalty-goal-symbol.svg"/>
                                    <span class="l-outer-margin minor-text main-secondary-color">{{ firstPlayerField(event) }}</span>
                                </div>
                            </div>
                            <div v-else-if="event.type=='ownGoal'" class="own-goal-type">
                                <div v-if="event.firstPlayerName" class="vertical-center">
                                    <img src="@/assets/match-team-game/own-goal-symbol.svg"/>
                                    <span class="l-outer-margin minor-text main-secondary-color">{{ firstPlayerField(event) }}</span>
                                </div>
                            </div>
                            <div v-else-if="event.type=='red'" class="red-card-type">
                                <div v-if="event.firstPlayerName" class="vertical-center">
                                    <img src="@/assets/match-team-game/red-card-symbol.svg"/>
                                    <span class="l-outer-margin minor-text main-secondary-color">{{ firstPlayerField(event) }}</span>
                                </div>
                            </div>
                            <div v-else-if="event.type=='yellow'" class="yellow-card-type">
                                <div v-if="event.firstPlayerName" class="vertical-center">
                                    <img src="@/assets/match-team-game/yellow-card-symbol.svg"/>
                                    <span class="l-outer-margin minor-text main-secondary-color">{{ firstPlayerField(event) }}</span>
                                </div>
                            </div>
                            <div v-else-if="event.type=='yellow-red'" class="yellow-red-card-type">
                                <div v-if="event.firstPlayerName" class="vertical-center">
                                    <img src="@/assets/match-team-game/yellow-red-card-symbol.svg"/>
                                    <span class="l-outer-margin minor-text main-secondary-color">{{ firstPlayerField(event) }}</span>
                                </div>
                            </div>
                            <div v-else-if="event.type=='changes'" class="subsitution-type">
                                <div v-if="event.firstPlayerName" class="vertical-center">
                                    <img src="@/assets/match-team-game/substitution-down-symbol.svg"/>
                                    <span class="l-outer-margin minor-text main-secondary-color">{{ firstPlayerField(event) }}</span>
                                </div>
                                <div v-if="event.secondPlayerName" class="t-inner-margin vertical-center">
                                    <img src="@/assets/match-team-game/substitution-up-symbol.svg"/>
                                    <span class="l-outer-margin minor-text main-secondary-color">{{ secondPlayerField(event) }}</span>
                                </div>
                            </div>
                            <span class="iconfont iconfont-edit edit-btn" @click="onEditBtnClick(event)"></span>
                        </div>
                    </div>
                </div>
                <div class="time-slot justify-center vertical-center">
                    <div class="game-end">
                        <img src="@/assets/match-team-game/game-end-symbol.svg"/>
                    </div>
                </div>
            </div>
        </div>
        <div class="indicator-section">
            <div class="fixed-upon-bottom wp100 bg-white">
                <van-row type="flex" justify="center" class="u-outer-padding">
                    <van-col span="4" class="vertical-center justify-center">
                        <img src="@/assets/match-team-game/goal-symbol.svg"/>
                        <span class="l-inner-margin minor-text">{{ locale['goal'] }}</span>
                    </van-col>
                    <van-col span="4" class="vertical-center justify-center">
                        <img src="@/assets/match-team-game/penalty-goal-symbol.svg"/>
                        <span class="l-inner-margin minor-text">{{ locale['penalty-goal'] }}</span>
                    </van-col>
                    <van-col span="4" class="vertical-center justify-center">
                        <img src="@/assets/match-team-game/own-goal-symbol.svg"/>
                        <span class="l-inner-margin minor-text">{{ locale['own-goal'] }}</span>
                    </van-col>
                    <van-col span="4" class="vertical-center justify-center">
                        <img src="@/assets/match-team-game/assist-symbol.svg"/>
                        <span class="l-inner-margin minor-text">{{ locale['assist'] }}</span>
                    </van-col>
                    <van-col span="4" class="vertical-center justify-center">
                        <img src="@/assets/match-team-game/yellow-card-symbol.svg"/>
                        <span class="l-inner-margin minor-text">{{ locale['yellow-card'] }}</span>
                    </van-col>
                    <van-col span="4" class="vertical-center justify-center">
                        <img src="@/assets/match-team-game/red-card-symbol.svg"/>
                        <span class="l-inner-margin minor-text">{{ locale['red-card'] }}</span>
                    </van-col>
                </van-row>
            </div>
        </div>
    </div>
</template>

<style scoped>
.time-line {
    position: absolute;
    height: calc(100% - 10px);
    left: 50%;
    border-left: 1px solid #EBEDF0;
}
.time-section {
    width: 45px;
}
.game-start,
.game-end {
    z-index: 10;
}
.minute-unit {
    width: 25px;
    height: 25px;
    border-radius: 12px;
    background: #FFF;
    box-sizing: border-box;
    border: 1px solid #EBEDF0;
    z-index: 10;
}
.home-section,
.away-section {
    width: 149px;
}
.event-card {
    width: 129px;
    border-radius: 4px;
    background: #F7F8FA;
    padding: 8px 10px;
}
.edit-btn {
    position: absolute;
    right: 10px;
    top: 8px;
}
.indicator-section {
    height: 36px;
}
</style>